import {
  Children,
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";

import { CSSTransition } from "react-transition-group";
import HeaderProducts from "./HeaderProducts";
import { Link } from "react-router-dom";
import Modal from "../../../ui-kits/Modal";
import { getHeaderData } from "../../../services/miscRequestServices";
import mainLogo from "../../../assets/media/logo.svg";
import ArrowBack from "../../../assets/media/icons/arrowBack";
import {
  getLicenceNoticeTitle,
  getCopyrightTitle,
} from "../../../services/pagesRequestServices";
import styled from "styled-components";
import Menu from "../../../assets/media/icons/menu";

import "./Header.scss";

const productMenuItem = {
  idx: 999,
  title: "محصولات",
  component: <HeaderProducts />,
};

const Header = (props) => {
  const [isShowMenu, toggleIsShowMenu] = useState(false);
  const [selectedMenu, changeSelectedMenu] = useState(null);
  const [menuData, changeMenuData] = useState([]);
  const [isNarrowed, toggleIsNarrowed] = useState(false);
  const [licenseNotice, changeLicenseNotice] = useState(null);
  const [copyrightText, changeCopyrightText] = useState(null);
  const getLiceneNotice = useCallback(() => {
    return getLicenceNoticeTitle().then((res) => changeLicenseNotice(res));
  }, []);

  const getCopyrightText = useCallback(() => {
    return getCopyrightTitle().then((res) => changeCopyrightText(res));
  }, []);

  useEffect(() => {
    getLiceneNotice();
    getCopyrightText();
  }, [getLiceneNotice, getCopyrightText]);

  const getMenuData = useCallback(() => {
    return getHeaderData().then(({ results }) =>
      changeMenuData([
        productMenuItem,
        ...results.filter((x) => x.url !== "/products"),
      ])
    );
  }, []);

  useEffect(() => {
    getMenuData();
  }, [getMenuData]);

  useLayoutEffect(() => {
    if (window.innerWidth > 768) {
      changeSelectedMenu(productMenuItem.idx);
    }
  }, []);

  const onScrollChanged = useCallback(() => {
    toggleIsNarrowed(window.scrollY > 100);
  }, [toggleIsNarrowed]);

  useLayoutEffect(() => {
    document.addEventListener("scroll", onScrollChanged, { passive: true });

    return () => document.removeEventListener("scroll", onScrollChanged);
  }, [onScrollChanged]);

  // const onChangePage = withRouter((link) => {
  //   props.history.push(link);
  //   toggleIsShowMenu(false);
  // });

  let locationProduct = window.location.pathname.includes("/products/");
  return (
    <Styles
      className={`header_main-container${isNarrowed ? " is-narrowed" : ""}`}
    >
      <div className="header_main-left">
        <Link to="/">
          <img src={mainLogo} alt="" />
        </Link>
        <span className="header_main-license-notice me-4 text-white">
          {licenseNotice?.title}
        </span>
      </div>
      {locationProduct ? (
        <a href={`/products`} className="icon-back">
          <ArrowBack />
        </a>
      ) : null}
      {!locationProduct ? (
        <button className="icon-menu" onClick={() => toggleIsShowMenu(true)}>
          <Menu />
        </button>
      ) : null}

      <Modal maintainRoot={isShowMenu}>
        <CSSTransition
          in={isShowMenu}
          timeout={100}
          classNames="menu-screen"
          unmountOnExit
        >
          <div>
            <div className="modal-header_container d-flex flex-row align-items-center justify-content-between px-md-5 py-md-3">
              <Link
                to="/"
                onClick={() => {
                  toggleIsShowMenu(false);
                }}
              >
                <img src={mainLogo} alt="" />
              </Link>
              <button
                className="icon-back"
                style={{
                  background: "none",
                  outline: "none",
                  padding: "5px",
                  border: "2px solid white",
                  borderRadius: "50%",
                }}
                onClick={() => {
                  toggleIsShowMenu(false);
                  changeSelectedMenu(false);
                }}
              >
                <ArrowBack />
              </button>
            </div>
            <div className="menu-screen_container row h-75 px-0 px-md-4 mx-0">
              <div className="menu_sidebar-right col-12 col-md-3 px-0 px-md-2 py-3 py-md-0 d-md-inline-flex flex-column justify-content-start my-3">
                {Children.toArray(
                  menuData.map((item) =>
                    item?.component ? (
                      <>
                        <div>
                          <button
                            className={`btn text-text-color text-end font-weight-600 menu_button__hover ${
                              selectedMenu === item.idx
                                ? "text-24 text-md-36"
                                : ""
                            }`}
                            onClick={() =>
                              changeSelectedMenu(
                                selectedMenu === item.idx ? "" : item.idx
                              )
                            }
                          >
                            {item.title}
                          </button>
                        </div>
                        <div
                          className={`d-md-none ${
                            selectedMenu === item.idx ? "d-block" : "d-none"
                          }`}
                        >
                          {item.component}
                        </div>
                        <hr className="d-md-none d-block border" />
                      </>
                    ) : (
                      <>
                        <div>
                          <Link
                            to={item.url ? item.url : "/"}
                            className={`btn text-text-color text-end font-weight-600 menu_button__hover ${
                              selectedMenu === item.idx
                                ? "text-24 text-md-36"
                                : ""
                            }`}
                            onClick={() => toggleIsShowMenu(false)}
                          >
                            {item.title}
                          </Link>
                        </div>
                        <hr className="d-md-none d-block border" />
                      </>
                    )
                  )
                )}
                <div className="header_menu__copyright text-white text-10">
                  {copyrightText?.title}
                </div>
              </div>
              <div className="menu_sidebar-left col text-text-color d-none d-md-block">
                <div>
                  {menuData.find((i) => i.idx === selectedMenu)?.component}
                </div>
              </div>
            </div>
          </div>
        </CSSTransition>
      </Modal>
    </Styles>
  );
};

export default Header;

const Styles = styled.div`
  .icon-back {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid white;
    border-radius: 50%;
    padding: 5px;
    background: none;
  }
  .icon-menu {
    border: 2px solid white;
    border-radius: 50%;
    padding: 8px;
    background: none;
  }
`;
